import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = ["aria-label", "aria-pressed", "disabled", "onClick", "onKeydown", "onMouseenter"];
const _hoisted_3 = {
    key: 0,
    class: "text-sm text-gray-500"
};
import { ref } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'StarRatingSelector',
    props: {
        modelValue: {},
        readonly: { type: Boolean, default: false }
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const hovered = ref(null);
        function isActive(star) {
            if (props.readonly)
                return props.modelValue !== null && star <= props.modelValue;
            if (hovered.value !== null)
                return star <= hovered.value;
            return props.modelValue !== null && star <= props.modelValue;
        }
        function select(star) {
            emit("update:modelValue", star);
        }
        function handleKeydown(event, star) {
            if (props.readonly)
                return;
            if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                select(star);
            }
            else if (event.key === "ArrowRight" || event.key === "ArrowUp") {
                event.preventDefault();
                if (star < 5)
                    select(star + 1);
            }
            else if (event.key === "ArrowLeft" || event.key === "ArrowDown") {
                event.preventDefault();
                if (star > 1)
                    select(star - 1);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                role: "group",
                "aria-label": _ctx.$t('reviews.submission.rating_label'),
                class: "flex items-center gap-2"
            }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                    return _createElementVNode("button", {
                        key: star,
                        type: "button",
                        "aria-label": `${star} ${star === 1 ? _ctx.$t('reviews.accessibility.star') : _ctx.$t('reviews.accessibility.stars')}`,
                        "aria-pressed": __props.modelValue !== null && star <= __props.modelValue,
                        disabled: __props.readonly,
                        class: _normalizeClass(["flex h-9 w-9 items-center justify-center rounded transition-transform focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 focus-visible:ring-offset-2", [
                                __props.readonly ? 'cursor-default' : 'cursor-pointer hover:scale-110 active:scale-95',
                            ]]),
                        onClick: ($event) => (!__props.readonly && select(star)),
                        onKeydown: ($event) => (handleKeydown($event, star)),
                        onMouseenter: ($event) => (!__props.readonly && (hovered.value = star)),
                        onMouseleave: _cache[0] || (_cache[0] = ($event) => (!__props.readonly && (hovered.value = null)))
                    }, [
                        (_openBlock(), _createElementBlock("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 24 24",
                            class: _normalizeClass(["h-7 w-7 transition-colors", isActive(star) ? 'fill-amber-400 text-amber-400' : 'fill-transparent text-gray-300']),
                            stroke: "currentColor",
                            "stroke-width": "1.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                        }, [...(_cache[1] || (_cache[1] = [
                                _createElementVNode("path", { d: "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" }, null, -1)
                            ]))], 2))
                    ], 42, _hoisted_2);
                }), 64)),
                (__props.modelValue)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(__props.modelValue) + " / 5 ", 1))
                    : _createCommentVNode("", true)
            ], 8, _hoisted_1));
        };
    }
});
